@if (currentMode === FieldMode.READ && !isCreatingEntity) {
  <div class="read-field-container">
    <div [hidden]="!viewToggled"
         [ngClass]="{'no-value': !accessManager.hasAllNeededPermissions(permissionsForEdition) || !asyncPreconditionsForEdition}"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-center">
      <div class="field-label fx-flex-100-33-percent">
        {{ fieldConfig.label }}
        @if (fieldConfig.tooltip) {
          <span [matTooltipPosition]="'below'"
                [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
            <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
          </span>
        }
      </div>
      <div class="field-container fx-flex-100-66-percent fx-layout-col">
        <div (click)="onActivate($event)" (keyup.enter)="onActivate($event)" tabindex="0"
             [ngClass]="{'read-value':accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition, 'computed': !(accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition)}">
          @if (assetValues?.length > 0) {
            <mat-chip-listbox tabIndex="-1" selectable="false">
              @for (chip of (assetValues | slice:0:5); track chip.id) {
                @if (accessManager.hasAccessToRelatedAsset(chip, appManager.currentOrganization.id)) {
                  <mat-chip-option class="clickable-field" (click)="onActivate($event)"
                                   (keyup.enter)="onActivate($event)">
                    <a (click)="navigateToAssetDashboard(chip.id)">
                      {{ (chip.toString().length > 30 ? chip.toString().slice(0, 27) + '...' : chip.toString()) }}
                    </a>
                  </mat-chip-option>
                } @else {
                  <mat-chip-option (click)="onActivate($event)" (keyup.enter)="onActivate($event)">
                    <span>
                      {{ (chip.toString().length > 30 ? chip.toString().slice(0, 27) + '...' : chip.toString()) }}
                    </span>
                  </mat-chip-option>
                }
              }
              @if (assetValues?.length > 5) {
                <div class="chips-container fx-layout-row fx-align-center">
                  <span>
                    {{ 'TOOLTIP.AND_MORE' | translate: {quantity: (assetValues.length - 5)} }}
                  </span>
                </div>
              }
            </mat-chip-listbox>
          } @else {
            <span>{{ appConfig.EMPTY_FIELD_VALUE }}</span>
          }
          @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
            <span class="overlay-icon">
              @if (preconditionsForEdition && asyncPreconditionsForEdition) {
                <mat-icon fontSet="mdi" fontIcon="mdi-pencil" class="selectable"></mat-icon>
              } @else {
                <mat-icon fontSet="mdi" fontIcon="mdi-pencil-off" [matTooltipPosition]="'below'" [matTooltip]="'TOOLTIP.READ_ONLY_VALUE' | translate" class="tooltip-icon"></mat-icon>
              }
            </span>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (currentMode === FieldMode.EDIT || isCreatingEntity) {
  <div>
    <div [hidden]="!editToggled || !viewToggled"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      @if (!isCreatingEntity) {
        <div class="field-label fx-flex-100-33-percent">
          {{ fieldConfig.label }}
          @if (fieldConfig.tooltip) {
            <span [matTooltipPosition]="'below'"
                  [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
              <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
            </span>
          }
        </div>
      }
      <div #fieldContainer class="field-container fx-flex-100-66-percent-min-500 fx-layout-col">
        <form autocomplete="off" class="chips-field-builder-form" [formGroup]="form">
          <mat-form-field appearance="outline">
            <mat-label>{{ fieldConfig.label }}</mat-label>
            <mat-chip-grid #chipList>
              @for (relatedAsset of (selectedEntities| slice:0:5); track relatedAsset.id) {
                <mat-chip-row (removed)="selectToggle(relatedAsset)"
                              [removable]="true">
                  {{ (relatedAsset.toString().length > 30 ? relatedAsset.toString().slice(0, 27) + '...' : relatedAsset.toString()) }}
                  @if (asyncPreconditionsForEdition) {
                    <button matChipRemove>
                      <mat-icon fontSet="mdi" fontIcon="mdi-close-circle"></mat-icon>
                    </button>
                  }
                </mat-chip-row>
              }
              @if (selectedEntities.length > 5) {
                <div class="chips-container fx-layout-row fx-align-center">
                  <span>
                    {{ 'TOOLTIP.AND_MORE' | translate: {quantity: (selectedEntities.length - 5)} }}
                  </span>
                </div>
              }
              @if (asyncPreconditionsForEdition) {
                <input #inputField #trigger="matAutocompleteTrigger"
                       formControlName="field"
                       (keyup.escape)="onEscapeCancel($event)"
                       [matAutocomplete]="suggestions"
                       [matChipInputFor]="chipList"
                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                       class="chip-input"
                       type="text">
              }
            </mat-chip-grid>
            <mat-autocomplete #suggestions="matAutocomplete"
                              [panelWidth]="fieldContainer.offsetWidth - 90"
                              (optionSelected)="keepPanelOpen()">
              @if (assetOptions$ | async; as assetOptions) {
                <cdk-virtual-scroll-viewport [itemSize]="appConfig.CDK_VIEWPORT_ITEM_HEIGHT"
                                             (scrolledIndexChange)="onScroll($event)"
                                             [appendOnly]="true"
                                             [maxBufferPx]="2 * appConfig.CDK_VIEWPORT_ITEM_HEIGHT * appConfig.CDK_VIEWPORT_MAXIMUM_ITEM_COUNT"
                                             [minBufferPx]="appConfig.CDK_VIEWPORT_ITEM_HEIGHT * appConfig.CDK_VIEWPORT_MAXIMUM_ITEM_COUNT"
                                             [style.height]="viewportHeight">
                  @if (assetOptions.length > 0) {
                    <mat-option class="suggestion">
                      <div class="checkbox-container fx-layout-row fx-align-center"
                           (click)="optionClicked($event)">
                        <mat-checkbox [checked]="allSelected" class="checkbox">
                          {{ 'GRID.SELECT_ALL' | translate }}
                        </mat-checkbox>
                      </div>
                    </mat-option>
                  }

                  <mat-option *cdkVirtualFor="let assetOption of assetOptions" [value]="assetOption"
                              class="suggestion">
                    <div class="checkbox-container fx-layout-row fx-align-center"
                         (click)="optionClicked($event, assetOption)">
                      <mat-checkbox [checked]="assetOption.checked" class="checkbox">
                        {{ assetOption.asset.toString() }}
                      </mat-checkbox>
                    </div>
                  </mat-option>

                </cdk-virtual-scroll-viewport>
              }
            </mat-autocomplete>
            @if (isCreatingEntity && fieldConfig.tooltip) {
              <span matTextSuffix matTooltipPosition="below"
                    [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
                <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
              </span>
            }
            @for (validator of erroredValidators; track validator.type) {
              <mat-error>
                {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
              </mat-error>
            }
            @if (form.controls.selectedAssetIds.hasError('required')) {
              <mat-error>
                {{ 'ERROR.FIELD_REQUIRED' | translate }}
              </mat-error>
            }
            @if (!asyncPreconditionsForEdition) {
              <mat-hint style="width:80%">
                {{ 'VALIDATION.PROJECT_IS_NOT_EDITABLE' | translate }}
              </mat-hint>
            }
          </mat-form-field>
        </form>
        @if (isSingleField) {
          <div class="save-options">
            <button (click)="onClickCancel()" (keyup.escape)="onEscapeCancel($event)" class="button">
              <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
            </button>
            <button (click)="onClickSave()" (keyup.escape)="onEscapeCancel($event)"
                    [disabled]="!form.valid || !asyncPreconditionsForEdition"
                    class="button save">
              <mat-icon fontSet="mdi" fontIcon="mdi-check"></mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
